import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styled from "styled-components";

export const StyledConfirmRemainingButton = styled(Button)`
    height: 50px;
    border-radius: 50px;
    width: 100%;
    font-size: 16px;
    background-color: #49aa19;
    margin-top: 24px;
    font-weight: 400;
`;

export const StyledCancelRemainingButton = styled(Button)`
    text-decoration: underline;
    margin-top: 16px;
    width: 100%;
    text-underline-offset: 3px;
    font-weight: 400;
`;

export const StyledDangerIcon = styled(ExclamationCircleOutlined)`
    font-size: 24px;
    color: #bf2e2d;
    position: absolute;
    left: 17px;
    top: 17px;
`;
